import { useEffect, useState } from 'react'
import { ReviewPager, ReviewWall, StarsRow } from '../components/ReviewTimeline'
import { api, type Review, type ReviewStats } from '../lib/api'

const PER_PAGE = 24

export function ReviewsPage() {
  const [items, setItems] = useState<Review[]>([])
  const [stats, setStats] = useState<ReviewStats | null>(null)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let alive = true
    setLoading(true)
    api
      .reviews({ page, per_page: PER_PAGE })
      .then((r) => {
        if (!alive) return
        setItems(r.items)
        setStats(r.stats)
        setTotalPages(r.total_pages || 1)
      })
      .catch(() => alive && setItems([]))
      .finally(() => alive && setLoading(false))
    return () => {
      alive = false
    }
  }, [page])

  function goPage(p: number) {
    setPage(p)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <>
      <h1 className="page-title">Đánh giá</h1>
      {stats ? (
        <p className="buykey-rev-summary">
          <StarsRow n={Math.round(stats.avg)} />
          <strong>{stats.avg.toFixed(1).replace('.', ',')}/5</strong>
          <span className="muted">· {stats.count.toLocaleString('vi-VN')} đánh giá</span>
        </p>
      ) : (
        <p className="page-lead">Đang tải…</p>
      )}

      {loading && !items.length ? <p className="muted">Đang tải đánh giá…</p> : null}
      <ReviewWall
        items={items}
        onReplied={(id, reply) =>
          setItems((list) => list.map((x) => (x.id === id ? { ...x, admin_reply: reply } : x)))
        }
      />
      {!loading && !items.length ? <p className="muted">Chưa có đánh giá.</p> : null}
      <ReviewPager page={page} totalPages={totalPages} disabled={loading} onPage={goPage} />
    </>
  )
}
